import React, { useState, useEffect } from 'react';
import { auth } from './config/firebase.js';
import { onAuthStateChanged } from 'firebase/auth';
import Dashboard from './components/Dashboard/Dashboard.jsx';
import Login from './components/Login.jsx';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <h1>HommeConnectPro</h1>
        <p>Verificando credenciales...</p>
      </div>
    );
  }

  return (
    <div className="App">
      {user ? <Dashboard /> : <Login />}
    </div>
  );
}

export default App; 


// Forzando la actualización del workflow